import { useQuery } from "@tanstack/react-query"
import { integrationsStatusQuery } from "../lib/integrationsStatusQuery"

export function useIntegrationsStatusQuery(...args: Parameters<typeof integrationsStatusQuery>) {
  return useQuery(integrationsStatusQuery(...args))
}
